module.exports = __webpack_public_path__ + "img/abtot-white.ddb5eda3.png";